import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import logo from "../../../logo.svg";
import {
  useAddSettingsMutation,
  useSettingsQuery,
} from "../../../services/settingsApi";
import { JwtReValidate, signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
import PhotoUploader from "../../Common/photoUpload/photoUpload";
//icons
import { CiSaveUp2 } from "react-icons/ci";
import { IoSave } from "react-icons/io5";

const GeneralSettings = () => {
  const PHOTO_BASE_URL =
    process.env.REACT_APP_PHOTO_URL || "http://localhost:5001";
  const user = signInUser();
  const { aamarId } = user;
  const lang = useSelector((state) => state.languageReducer);

  // console.log("USER::>>", user);
  const { data: settings, isSuccess, refetch } = useSettingsQuery(aamarId);
  const [addSettings] = useAddSettingsMutation();
  const [storePhoto, setStorePhoto] = useState(null);

  const { register, handleSubmit, reset, setValue } = useForm();

  // Handle form submission
  const onSubmit = async (data, message) => {
    const currentPhoto = storePhoto || settings?.storePhoto || settings?.photo;
    const payload = {
      ...data,
      ...(currentPhoto ? { storePhoto: currentPhoto, photo: currentPhoto } : {}),
      aamarId: aamarId,
    };
    // console.log("Payload for submission:", data);
    const response = await addSettings(payload);
    // console.log("Response", response);
    if (response?.data) {
      await JwtReValidate();

      refetch();
      notify(message, "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  // photo upload

  useEffect(() => {
    if (isSuccess && settings) {
      reset(settings);
      const currentPhoto = settings?.storePhoto || settings?.photo || settings?.data?.photo;
      if (currentPhoto) {
        setStorePhoto(currentPhoto);
        setValue("storePhoto", currentPhoto);
        setValue("photo", currentPhoto);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, settings, reset]);

  const updatePhotUrl = async (url) => {
    setStorePhoto(url);
    setValue("storePhoto", url);
    setValue("photo", url);
    const payload = {
      storePhoto: url,
      photo: url,
      aamarId: aamarId,
    };
    const response = await addSettings(payload);
    if (response?.data) {
      await JwtReValidate();
      refetch();
      notify("Logo Upload Successful", "success");
    } else {
      notify("Failed to add settings.", "error");
    }
  };

  return (
    <div className="">
      <div>
        {/* Generale Settings Section */}
        <div>
          <h5 className="mb-3 d-flex align-content-center gap-2">
            <Icons.CogOutline size={25} /> General Settings
          </h5>
          <hr />
          {/* E-Commerce Logo */}
          <div className="d-flex justify-content-center align-items-start">
            <PhotoUploader
              uploadSuccess={updatePhotUrl}
              aspectRatio={8 / 2}
              folderName={aamarId}
              maxFileSize={1 * 1024 * 1024} // 1MB
              acceptedFileTypes={[
                "image/jpg",
                "image/jpeg",
                "image/svg",
                "image/png",
                "image/webp",
              ]}
              image={storePhoto || settings?.storePhoto || settings?.photo || null}
              placeholder={logo}
            />
          </div>
        </div>
        <form
          // style={{ marginTop: "80px" }}
          onSubmit={handleSubmit((data) =>
            onSubmit(data, "Basic Settings added successfully!")
          )}
        >
          <div className="mb-4">
            <div className="row mb-2">
              <label className="col-sm-2 col-form-label">Site Title</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  className="form-control"
                  {...register("siteTitle")}
                  placeholder="Site Title"
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-8">
                <label className="col-sm-4 col-form-label">Tag Line</label>
                {/* <div className="col-sm-8"> */}
                <input
                  type="text"
                  className="form-control"
                  {...register("tagLine")}
                  placeholder="Tag Line"
                />
                {/* </div> */}
              </div>
              <div className="col-sm-4">
                <label className="col-form-label">Store Status</label>
                <div className="input-group">
                  <select className="form-select" {...register("storeStatus")}>
                    <option value="live"> Live</option>
                    <option value="maintenance">Maintenance</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-4">
              <button
                type="submit"
                className="btn btn-dark d-flex justify-content-center align-items-center gap-2"
              >
                <IoSave size={16} className="me-1" />
                <span>Save</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default GeneralSettings;
